import React from 'react'
import requestStatus from '../../../../constants/requestStatus'
import ListDropItems from '../../../DragAndDropList/presents/ListDropItems.jsx'
import { MOVIE } from '../../../../constants/itemTypes'
import ButtonSubmit from '../../../general/ButtonSubmit.jsx'
import ListDragByConfig from '../../../DragAndDropList/presents/ListDragByConfig.jsx'
import PushDragSwitch from './PushCreateDragSwitch.jsx'
import PushCreateForm from './PushCreateForm.jsx'

const PushCreatePage = ({    
    basicUrl,
    cliCinemas,
    clientCinemaId,
    disableButton,
    displayDropzones,
    dragListConfig,
    movieItemsData,
    movieItemsDataCallback,
    onAttachedItemUpdate,
    onCreatePush,
    onFormUpdate,
    pushCreateData,
    status,
}) => {

    const displayDropzonesClass = displayDropzones ? ' dropzones' : ''

    const { INITIALIZED, REQUEST_PENDING, REQUEST_SUCCESS, REQUEST_ERROR } = requestStatus

    let buttonTextTransId = null
    if (INITIALIZED === status) {
        buttonTextTransId = 'push_create_button'
    } else if (REQUEST_PENDING === status) {
        buttonTextTransId = 'push_create_button_pending'

    } else if (REQUEST_SUCCESS === status) {
        buttonTextTransId = 'push_create_button_sent'
    } else {
        buttonTextTransId = 'push_error'
    }

    return (

        <div className="program-page program-page-edit-selection site-content">
            <div className="selections-item">
                <div className="selections-item-content accordion-item">
                    {/* <p className="selection-drag-hint title-large-light"><Translation id="section_page_drag_movies_to_sort" /></p> */}
                    <div className={"selections-item-selections section-left" + displayDropzonesClass}>
                        {/* <FlyerSmallPagePreview
                        outside={false}
                        sectionActive={side + '-' + section}
                        side={side}
                        flyerStructureData={flyerData.flyerStructure}
                    /> */}
                        <ListDragByConfig
                            dragListConfig={dragListConfig}
                            itemsData={movieItemsData}
                            itemsDataCallback={movieItemsDataCallback}
                            basicUrl={basicUrl}
                            defaultIsOpen={true}
                            ChildSwitchItem={PushDragSwitch}
                            //addNewItem={onAddItem}
                            //onDeleteItem={onDeleteItem}
                        />
                    </div>


                    {<div className={"selections-item-periodes custom-content section-center" + displayDropzonesClass}>

                        <ul className="periode-list gap-35">

                            <ListDropItems
                                listId='list-movie'
                                items={movieItemsData.items}
                                order={movieItemsData.selectedItems}
                                itemType={MOVIE}
                                displayDropzones={displayDropzones}
                                ChildSwitchItem={PushDragSwitch}
                                basicUrl={basicUrl}
                                canEdit={false}
                                canDelete={true}
                                addItem={(listId, itemId, itemType) => { 
                                    let item = {
                                        "listId": listId,
                                        "itemId":itemId,
                                        "itemType":itemType,
                                        "item": movieItemsData.items[itemId]
                                    }
                                    onAttachedItemUpdate(item)
                                }}
                                deleteItem={(listId, itemId, itemType) => { 
                                    onAttachedItemUpdate(null)
                                 }}
                            />
                        </ul>

                        <PushCreateForm item={pushCreateData.form} onUpdateItem={onFormUpdate} cliCinemas={cliCinemas} clientCinemaId={clientCinemaId} enabledCinemaIds={movieItemsData.enabledCinemaIds} />
                        
                    </div>}


                    




                    {/*                 
                <div className="selections-item-periodes section-right">

                    PREVIEW

                    { <FlyerPreviewContainer
                        currentCinemaId={cinemaId}
                        activeWeek={week}
                        section={section}
                        side={side}
                       
                        printType={printType}
                        printFormat={printFormat}
                        landscape={landscape}
                        flyerData={flyerData}
                    /> }
                </div>
                 */}

                    <div className={"save-program-button" + (disableButton ? " disabled" : "")}>
                        <ButtonSubmit
                            transIdSubmit={buttonTextTransId}
                            onSubmit={() => !disableButton && onCreatePush()}
                            disableTemporarily={disableButton}
                            disablePermanently={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    )

}

export default PushCreatePage